import { resolveId } from '@wix/communities-blog-client-common';

export function getChannel(entity) {
  return `${entity.type}-${resolveId(entity)}`;
}
